
















































































































































































































import {Component, Prop, Provide, Vue} from "vue-property-decorator";
import User from "@/apiClient/User";
import Menu from "@/apiClient/Menu";
import Actions from "../../../apiClient/Actions";
import Employee from "../../../apiClient/Employee";
import MailEdit from "./mail-edit/MailEdit.vue";
import PassEdit from "./pass-edit/PassEdit.vue";
import SwitchUser from "./switch-user/SwitchUser.vue";
import AvatarEdit from "./avatar-edit/AvatarEdit.vue";
import {mapGetters, mapActions} from "vuex";
import swal from "sweetalert2";
import bus from "../../../bus";
import _ from "lodash";
import axios from "axios";
import bodymovin from "lottie-web";
import downloadModal from '@/components/menu/header-top/download-backup/downloadModal.vue'
import BuildingIcon from "./icons/BuildingIcon.vue";
import UserIcon from "./icons/UserIcon.vue";
import FileIcon from "./icons/FileIcon.vue";
import ExitIcon from "./icons/ExitIcon.vue";
import ArrowDownIcon from "./icons/ArrowDownIcon.vue";
declare var mLayout: any;
declare var mApp: any;

@Component({
  name: "HeaderTop",
  components: { 
    MailEdit, 
    PassEdit, 
    SwitchUser, 
    AvatarEdit, 
    downloadModal,
    BuildingIcon,
    UserIcon,
    FileIcon,
    ExitIcon,
    ArrowDownIcon,
  },
  filters: {
    titleCase(value: string) {
      if (!value) return '';
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    }
  },
  computed: {
    ...mapGetters([
      "getRelated",
      "getActions",
      "getMenu",
      "getUser",
      "getSSOData",
      "getFactoryQueryParam"
    ]),
    fromSSO() {
      if (this.getSSOData) return this.getSSOData.sso;
    },
  },
  methods: {
    ...mapActions(["setInitialCountry"])
  },
  beforeMount() {
    this.$forceUpdate();
    const factory = parseInt(this.getFactoryQueryParam, 10)
    const id = this.$store.getters.getUser.empresa.id
    if (factory === id) {
      this.checkDownloadAvailable()
    }
  }
})
export default class HeaderTop extends Vue {
  @Prop({ required: true }) name: string;
  @Prop({ required: true }) lastname: string;
  @Prop({ required: true }) code: number;
  @Prop({ required: true }) email: string;
  @Prop({ required: true }) company: string;
  @Prop({ required: true }) userpic: string;
  @Prop({ required: true }) logout: {};

  @Provide() closeDownloadDialog = this.closeDialog

  public readonly EMPLOYEE_PROFILE = 1;
  public readonly ADMIN_PROFILE = 2;

  user: User;
  related: any;
  getRelated!: any[];
  getActions!: any[];
  getMenu!: any[];
  getUser!: any[];
  imgAvatar: string;
  isPasswordExpired: boolean;
  modalActive: boolean;
  titleModal: string;
  componentBodyModal: any;
  modalSuccessActive: boolean;
  contentSuccessModal: string;
  profile: number;
  domain: string;
  modalWidth: string;
  modalDownloadActive: boolean;
  modalDownloadErrorStatus: boolean;
  modalDownloadMfaErrorStatus: boolean;
  fileLink: string;
  navOpen: boolean;
  setInitialCountry: () => void;
  data() {
    return {
      user: User,
      mail: this.email,
      related: [],
      imgAvatar: "",
      isPasswordExpired: false,
      modalActive: false,
      titleModal: "",
      componentBodyModal: "",
      modalSuccessActive: false,
      contentSuccessModal: "",
      profile: 0,
      domain: "",
      modalWidth: "48rem",
      modalDownloadActive: false,
      modalDownloadErrorStatus: false,
      modalDownloadMfaErrorStatus: false,
      fileLink: '',
      navOpen: false
    };
  }

  created() {
    console.log('userpic:', this.userpic);
    this.user = new User();
    this.user.relatedUsers().then((result) => {
      result.data.results.data.forEach((user) => {
        this.related.push(user);
      });
      this.$store.dispatch("setUserRelated", { related: this.related });
    });
    this.setInitialCountry();
    this.user
      .getAvatar(this.getUser["id"])
      .then(({ data }) => {
        this.imgAvatar = data;
        const storedConfig = localStorage.getItem('navBarConfig')
        const navBarConfig = storedConfig ? { ...JSON.parse(storedConfig) } : {}

        localStorage.setItem('navBarConfig', JSON.stringify({...navBarConfig, imgAvatar: data }))
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 404) {
            console.log("Error 404: GetAvatar");
          }
        }
      });

    // Vemos si hay usuario seteado en el localStorage y actualizamos el store para reflejar cambio de empresa de php a vue.js
    if (localStorage.getItem("user") !== null) {
      let user = JSON.parse(localStorage.getItem("user"));
      if (this.getUser && user) {
        let vuexUser = _.mapValues(this.getUser);
        let storageUser = user;

        if (user.id != this.getUser["id"]) {
          this.user.switchUser(user.id).then((response) => {
            this.$store.dispatch("setUser", {
              user: response.data.results.data[0],
            });
            this.updateMenu();
            bus.$emit(
              "userchange",
              Math.random()
                .toString(36)
                .substring(7)
            );
          });
        }

        if (vuexUser.mail !== storageUser.mail) {
          let mergedUser = Object.assign({}, this.getUser, {
            mail: storageUser.mail,
          });
          this.$store.dispatch("setUser", { user: mergedUser });
        }
      }
    }
    
  }

  openModal(goTo) {
    switch (goTo) {
      case "switchCompany":
        this.componentBodyModal = SwitchUser;
        this.titleModal = "Cambiar empresa";
        this.modalActive = !this.modalActive;
        this.modalWidth = "48rem";
        break;
      case "editPassword":
        this.componentBodyModal = PassEdit;
        this.titleModal = "Editar clave";
        this.modalActive = !this.modalActive;
        this.modalWidth = "30rem";
        break;
      case "editMail":
        this.componentBodyModal = MailEdit;
        this.titleModal = "Editar email";
        this.modalActive = !this.modalActive;
        this.modalWidth = "30rem";
        break;
      default:
        break;
    }
  }

  goToSwitchCompany() {
    this.isPasswordExpired = false;
  }

  onSwitch(selected, profileType, domain) {
    this.user.switchUser(selected).then((user) => {
      if (user.data.code === "00607") {
        this.isPasswordExpired = true;
        return;
      }
      let formdata = new FormData();
      let mensaje = "";
      formdata.append("userid", selected);

      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.jwt}`,
        },
      };

      axios
        .post(location.origin + `/switch.user`, formdata, config)
        .then((response: any) => {
          if (response.data.status === "success") {
            this.profile = profileType;

            if (profileType === this.EMPLOYEE_PROFILE) {
              this.modalActive = false;
              this.contentSuccessModal =
                "Se ha cambiado de perfil, ingrese su usuario y contraseña en la nueva ventana.";
              this.modalSuccessActive = true;
              this.domain = domain;
            } else if (profileType === this.ADMIN_PROFILE) {
              this.modalActive = false;
              this.contentSuccessModal = "Se ha cambiado de empresa.";
              this.modalSuccessActive = true;
              this.$store.dispatch("setUser", {
                user: user.data.results.data[0],
              });
              localStorage.setItem(
                "user",
                JSON.stringify(user.data.results.data[0])
              );
              localStorage.removeItem('actions') 
              this.$store.commit('CLEAR_PROFILE')
              this.updateMenu();
            }
          }
        })
        .finally(() => {});
    });
  }

  goToEmployee() {
    this.profile = 0;
    bus.$emit(
      "userchange",
      Math.random()
        .toString(36)
        .substring(7)
    );
    const path = "/home";
    if (this.$route.path !== path) {
      this.$router.push("/home");
    }
    this.modalSuccessActive = false;
    window.open(`${location.protocol}//${this.domain}`, "_blank");
  }

  changeCompany() {
    this.profile = 0;
    bus.$emit(
      "userchange",
      Math.random()
        .toString(36)
        .substring(7)
    );
    this.modalSuccessActive = false;
    location.reload();
    this.$router.push("/home");
  }

  async checkDownloadAvailable() {
    try {
      const {data: { data }} = await this.user.getDownloadFile()
      this.modalDownloadActive = true
      this.modalDownloadErrorStatus = false
      this.fileLink = data.link
    } catch (e) {
      if (e.response && e.response.status !== 404) {
        const { code } = e.response.data.codes[0]
        if (code === 'SYSTEM_MFA_AUTH_NOT_CONFIGURED') {
          this.modalDownloadMfaErrorStatus = true
        }
      }
      this.modalDownloadErrorStatus = true
      this.modalDownloadActive = true
    }
  }
  closeDialog() {
    this.$store.dispatch('setParamLoginFactory','')
    this.modalDownloadActive = false
  }
  updateMenu() {
    let menu = new Menu();
    menu
      .getUser()
      .then((result: any) => {
        let res = result.status === 200 ? result.data.results.data : [];
        let fil = _.map(res, function(n: any) {
          return Number(n.id);
        });
        let actions = _.map(this.getActions, function(n, i) {
          return Number(i);
        });
        let userActions = _.filter(actions, function(n) {
          return _.includes(fil, n);
        });
        this.$store.dispatch("setPermissions", { permissions: fil });
        let _menu = this.getMenu;
        _.each(_menu, function(a) {
          a["childsavailable"] = _.intersection(a["childs"], userActions);
        });
        _.each(_menu, function(a) {
          if (a.childsavailable.length > 0) {
            a.shown = _.some(a.childsavailable, (action) =>
              _.includes(fil, Number(action))
            );
          } else {
            a.shown = fil.includes(a.id);
          }
        });

        _.each(actions, (action, clave) => {
          _.map(action, (menu, i) => {
            if (_.has(menu, "submenu")) {
              _.each(menu.submenu, (item, key) => {
                if (_.includes(fil, Number(item.id))) {
                  actions[clave][i].submenu[key].shown = true;
                }
              });
            }
          });
        });

        Object.keys(this.getActions).some((key) => {
          if (this.getActions[key][0].to === this.$route.name) {
            this.getActions[key][0].active = true;
            Object.keys(_menu).some((index) => {
              Object.keys(_menu[index].childs).some((i) => {
                if (_menu[index].childs[i] === parseInt(key)) {
                  _menu[index].active = true;
                  return false;
                }
              });
              return false;
            });
            return false;
          }
        });

        this.$store.dispatch("setMenu", { menu: _menu });
        this.$store.dispatch("setActions", { actions });
        mLayout.init({});
      })
      .catch((result: any) => {
        console.log("result", result);
      });
  }

  openNav() {
    this.navOpen = !this.navOpen
  }
  
  goToMyAccount() {
    window.location.href = window.origin +'/v3/user/self-service/mail-edit';
  }

  openPrivacyPdf() {
    window.open('/assets/media/pdf/privacidad.pdf', '_blank')
  }
}
